"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Spinner_1 = __importDefault(require("../shapes/Spinner"));
const colors_1 = require("../colors");
const getSpinnerSizeString = spinnerSize => (spinnerSize >= 72 ? 'large' : spinnerSize >= 38 ? 'medium' : 'small');
class CarouselLoading extends react_1.PureComponent {
    render() {
        const { size } = this.props;
        const spinnerSize = size / 3;
        return (react_1.default.createElement("div", { className: "item active", style: {
                backgroundColor: colors_1.silver,
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            react_1.default.createElement("div", { style: { height: spinnerSize } },
                react_1.default.createElement(Spinner_1.default, { size: getSpinnerSizeString(spinnerSize) }))));
    }
}
exports.default = CarouselLoading;
CarouselLoading.propTypes = {
    size: prop_types_1.default.number,
};
